import {
    respondToAbove,
    ScreenWidth,
} from '@superbet-group/web.lib.vue-utilities';
import { computed } from '@vue/composition-api';

export function useSdsCarouselBreakpointVariant({
    screenWidth = ScreenWidth.tSm,
    fixedLayoutValue = 2,
    autoLayoutValue = 284,
}: Partial<{
    screenWidth: ScreenWidth;
    fixedLayoutValue: number;
    autoLayoutValue: number;
}> = {}) {
    const carouselLayoutVariant = computed(() => {
        return respondToAbove(screenWidth) ? 'fixed' : 'auto';
    });

    const carouselLayoutValue = computed(() => {
        return respondToAbove(screenWidth) ? fixedLayoutValue : autoLayoutValue;
    });

    return {
        carouselLayoutVariant,
        carouselLayoutValue,
    };
}
